module.exports = __webpack_public_path__ + "static/media/23.da8b866a.png";